import axios from 'axios'

import envObj from '@/config/env'
import { ConsentData } from './types'

interface AcceptConsentProps {
  apiKey: string
  purposeId: string
  data: ConsentData
}

export async function acceptConsent({
  apiKey,
  purposeId,
  data,
}: AcceptConsentProps) {
  const res = await axios.post(
    envObj.CONSENT_WOW_API_URL,
    {
      first_name: data.name,
      last_name: data.surname,
      email: data.email,
      phone_number: data.phone_number,
      consents: [
        {
          status: 'accepted',
          consent_purpose_id: purposeId,
        },
      ],
    },
    {
      headers: {
        Authorization: apiKey,
      },
    },
  )
  return res.data
}
